<template>
    <div class="select-wrapper select" :class="display">
        <select
            :value="value"
            @input="update">
            <option
                v-for="(o, i) in options"
                :key="i"
                :value="o.value"
                :theme="theme"
                :selected='i === initialSelected'
                :size="size">
                {{o.label}}
            </option>
        </select>
    </div>
</template>

<script>
    import { THEMES, SIZES } from '@/data/themes'

    export default {
        name: 'OSJSelect',
        props: {
            options : Array,
            theme : String,
            size : String,
            value : String,
            initialSelected:Number
        },
        data(){
            return {
                selected : null
            }
        },
        methods : {
            update( e ){
                this.$emit( "input", e.target.value )
            }
        },
        computed : {
            display () {
                return [
                    THEMES[this.theme] || THEMES.light,
                    SIZES[this.size] || SIZES.small,
                    this.selected ? 'selected' : undefined
                ]
            }
        }
    }
    
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    .select-wrapper{
        background-color: white;
        border: 1px solid $pale-gray;
        overflow: hidden;
        display: block;
        margin-bottom: 1rem;
        border-radius: $radius;
        text-align: left;
        cursor: pointer;
        position: relative;
        
        select{
            -moz-appearance: none;
            -webkit-appearance: none;
            appearance: none;
            background-color: white;
            background-image: url( "~@/assets/select-arrow.svg" );
            background-repeat: no-repeat;
            background-size: 1.6rem;
            background-position: right 1rem center;
            font-size: 1.2rem;
            border-radius: 0;
            border: none;
            width: 100%;
            max-width: 100%;
            padding: 1rem 1.5rem;
        }
    }
    
</style>